import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/accordions/FaqWithButton.jsx");
;
import(/* webpackMode: "eager" */ "/app/components/common/ParallaxContainer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/gitbiz/Pricing.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
